import * as Pedometer from './Pedometer';

export { default as Accelerometer, AccelerometerMeasurement } from './Accelerometer';
export { default as Barometer, BarometerMeasurement } from './Barometer';
export {
  default as DeviceMotion,
  DeviceMotionMeasurement,
  DeviceMotionOrientation,
} from './DeviceMotion';
export { default as DeviceSensor } from './DeviceSensor';
export { default as Gyroscope, GyroscopeMeasurement } from './Gyroscope';
export { default as Magnetometer, MagnetometerMeasurement } from './Magnetometer';
export {
  default as MagnetometerUncalibrated,
  MagnetometerUncalibratedMeasurement,
} from './MagnetometerUncalibrated';
export { default as LightSensor, LightSensorMeasurement } from './LightSensor';
export { Pedometer };
